import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";
import { CustomContactUsFormModel } from "@tCooneyBrothers/ApiModels";

const customContactUsUrl = "api/v2/emailnew";

export async function getCustomerPartNumbers() {
    try {
        const fieldCollection = await get<CustomContactUsFormModel[]>(`${customContactUsUrl}`, {})
            .then(response => {
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return fieldCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addCustomContactUsFields(parameter: CustomContactUsFormModel) {
    return post<CustomContactUsFormModel>(customContactUsUrl, parameter);
}
